import type { PriceCardUsp } from '../constants';
import { STANDALONE_USPS, SUBSCRIPTION_USPS } from '../constants';

export type PriceCardUspsVariant = string | null | undefined;

export type PriceCardPlanType = 'subscription' | 'standalone';

export type PriceCardFeature = string | PriceCardUsp;

export function getPriceCardFeatures({
  variant,
  planType,
  fallbackAllAccessFeatures,
  fallbackStandaloneFeatures,
}: {
  variant: PriceCardUspsVariant;
  planType: PriceCardPlanType;
  fallbackAllAccessFeatures: readonly string[];
  fallbackStandaloneFeatures: readonly string[];
}): PriceCardFeature[] {
  if (!variant || variant === 'variant_a') {
    return planType === 'standalone' ? [...fallbackStandaloneFeatures] : [...fallbackAllAccessFeatures];
  }

  return planType === 'standalone' ? [...STANDALONE_USPS] : [...SUBSCRIPTION_USPS];
}

export function getUspFeatureKey(feature: PriceCardFeature): string {
  return typeof feature === 'string' ? feature : feature.title;
}

export function shouldShowSubline(variant: PriceCardUspsVariant): boolean {
  return variant === 'variant_b';
}
